import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=29bcc328&scoped=true"
import script from "./PhoneLogin.vue?vue&type=script&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&lang=js"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=29bcc328&prod&scoped=true&lang=css"
import style1 from "./PhoneLogin.vue?vue&type=style&index=1&id=29bcc328&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bcc328",
  null
  
)

export default component.exports